"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToSecurities = exports.translateToSingleSecurity = exports.translateToOauth2SecurityScheme = exports.translateToApiKeySecurityScheme = exports.translateToBasicSecurityScheme = exports.translateToFlows = void 0;
const json_1 = require("@stoplight/json");
const pickBy = require("lodash.pickby");
const context_1 = require("../../context");
const guards_1 = require("../../guards");
const accessors_1 = require("../accessors");
const guards_2 = require("../guards");
const translateToFlows = function (security) {
    const flows = {};
    const scopes = (0, json_1.isPlainObject)(security.scopes) ? pickBy(security.scopes, guards_1.isString) : {};
    const authorizationUrl = 'authorizationUrl' in security && typeof security.authorizationUrl === 'string' ? security.authorizationUrl : '';
    const tokenUrl = 'tokenUrl' in security && typeof security.tokenUrl === 'string' ? security.tokenUrl : '';
    if (security.flow === 'implicit') {
        flows.implicit = {
            authorizationUrl,
            scopes,
        };
    }
    else if (security.flow === 'password') {
        flows.password = {
            tokenUrl,
            scopes,
        };
    }
    else if (security.flow === 'application') {
        flows.clientCredentials = {
            tokenUrl,
            scopes,
        };
    }
    else if (security.flow === 'accessCode') {
        flows.authorizationCode = {
            authorizationUrl,
            tokenUrl,
            scopes,
        };
    }
    return flows;
};
exports.translateToFlows = translateToFlows;
exports.translateToBasicSecurityScheme = (0, context_1.withContext)(function (security) {
    const key = security.key;
    return {
        id: this.generateId.httpSecurity({ keyOrName: key }),
        type: 'http',
        scheme: 'basic',
        key,
        ...pickBy({
            description: security.description,
        }, guards_1.isString),
    };
});
const ACCEPTABLE_SECURITY_ORIGINS = ['query', 'header'];
exports.translateToApiKeySecurityScheme = (0, context_1.withContext)(function (security) {
    if ('in' in security && security.in && ACCEPTABLE_SECURITY_ORIGINS.includes(security.in)) {
        const key = security.key;
        return {
            id: this.generateId.httpSecurity({ keyOrName: key }),
            type: 'apiKey',
            in: security.in,
            name: (0, guards_1.isString)(security.name) ? security.name : '',
            key,
            ...pickBy({
                description: security.description,
            }, guards_1.isString),
        };
    }
    return;
});
const VALID_OAUTH2_FLOWS = ['implicit', 'password', 'application', 'accessCode'];
exports.translateToOauth2SecurityScheme = (0, context_1.withContext)(function (security) {
    if (!security.flow || !VALID_OAUTH2_FLOWS.includes(security.flow))
        return undefined;
    const key = security.key;
    return {
        id: this.generateId.httpSecurity({ keyOrName: key }),
        type: 'oauth2',
        flows: exports.translateToFlows.call(this, security),
        key,
        ...pickBy({
            description: security.description,
        }, guards_1.isString),
    };
});
const translateToSingleSecurity = function (security) {
    if ((0, guards_2.isSecurityScheme)(security)) {
        switch (security.type) {
            case 'basic':
                return exports.translateToBasicSecurityScheme.call(this, security);
            case 'apiKey':
                return exports.translateToApiKeySecurityScheme.call(this, security);
            case 'oauth2':
                return exports.translateToOauth2SecurityScheme.call(this, security);
        }
    }
    return;
};
exports.translateToSingleSecurity = translateToSingleSecurity;
exports.translateToSecurities = (0, context_1.withContext)(function (operationSecurities) {
    this.context = 'service';
    const securities = (0, accessors_1.getSecurities)(this.document, operationSecurities);
    return securities.map(security => security.map(exports.translateToSingleSecurity, this).filter(guards_1.isNonNullable));
});
//# sourceMappingURL=securities.js.map